import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http'
import to from 'await-to-js';
import StoreEventStation from '../interfaces/StoreEventStation';
import * as moment from 'moment';
import { MyPromise } from '../interceptors/myPromise.service';

const EVENTS_API_URL_PHP = `${environment.baseEndpointPHP}/events`;
const CLEANING_EVENTS_API_URL_PHP = `${environment.baseEndpointPHP}/cleaning-events`;

@Injectable({
  providedIn: 'root',
})

export class EventService {

  constructor(private http: HttpClient, private myPromise: MyPromise) { }

  async getStationEvents(stationId: string) {
    return await to(this.http.get(`${EVENTS_API_URL_PHP}/station/${stationId}`).toPromise()) as any;
  }

  async getStationCleaningEvents(stationId: string) {
    return await to(this.http.get(`${CLEANING_EVENTS_API_URL_PHP}/station/${stationId}`).toPromise()) as any;
  }

  async store(event: StoreEventStation) {
    return await to(this.http.post(`${EVENTS_API_URL_PHP}/station/${event.station_id}`, event).toPromise()) as any;
  }

  async updateEvent(id: string, data: any) {
    return await to(this.http.put(`${EVENTS_API_URL_PHP}/${id}`, data).toPromise()) as any;
  }

  async disabledOrEnabled(id: string) {
    return await to(this.http.put(`${EVENTS_API_URL_PHP}/${id}/enabled-or-disabled`, {}).toPromise());
  }

  async disabledOrEnabledCleaningEvent(id: string) {
    return await to(this.http.put(`${CLEANING_EVENTS_API_URL_PHP}/${id}/enabled-or-disabled`, {}).toPromise());
  }

  async deleteEvent(id: string) {
    return await to(this.http.delete(`${EVENTS_API_URL_PHP}/${id}`).toPromise());
  }

  async deleteCleaningEvent(id: string) {
    return await to(this.http.delete(`${CLEANING_EVENTS_API_URL_PHP}/${id}`).toPromise());
  }

  async storeCleaningEvent(stationId: string, logbook: any, data = { column_field: '' }) {
    logbook.date = moment(logbook.date).format('YYYY-MM-DD');
    logbook.start_time = moment(logbook.start_time, 'h:mm a').format('H:mm');
    logbook.end_time = moment(logbook.end_time, 'h:mm a').format('H:mm');
    const postData = { ...logbook, ...data, frequency: logbook.fields.period }

    return this.myPromise.to(this.http.post(`${CLEANING_EVENTS_API_URL_PHP}/station/${stationId}`, postData));
  }

  async updateCleaningEvent(id: string, data: any) {
    return await to(this.http.put(`${CLEANING_EVENTS_API_URL_PHP}/${id}`, data).toPromise()) as any;
  }

}
